export default "__VITE_ASSET__DKR99$s2__"